import { inject }              from '@angular/core';
import { ResolveFn }           from '@angular/router';
import { Observable }          from 'rxjs';
import { TaxDocumentsService } from '../../../../api/tax-documents/tax-documents.service';

export const latestTaxYearResolver: ResolveFn<number> = (): Observable<number> => {
  return inject(TaxDocumentsService).getLatestTaxYear();
};
